import React from 'react'
import {useIntl, FormattedMessage} from 'react-intl'
import {ConsoleLogger} from 'aws-amplify/utils'
import TextField from '@material-ui/core/TextField'
import {makeStyles} from '@material-ui/core/styles'
import LoaderButton from 'components/atoms/LoaderButton'
import * as Api from 'lib/api'
import Auth from 'lib/auth'
import {useAuthentication} from 'components/providers/AuthenticationProvider'
import {Formik} from 'formik'
import * as Yup from 'yup'

const logger = new ConsoleLogger('SignUpConfirmationForm')

const ConfirmationSchema = Yup.object().shape({
  confirmationCode: Yup.string().required('formValidations.required'),
})

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

export const SignUpConfirmationForm = ({email, password}) => {
  const classes = useStyles()
  const intl = useIntl()
  const {signIn} = useAuthentication()

  const handleConfirmationSubmit = async (values, {setSubmitting}) => {
    try {
      await Auth.confirmSignUp(email, values.confirmationCode)
      await Auth.signIn(email, password)
      await Api.createUser({email})
      signIn()
    } catch (e) {
      logger.error(e)
      setSubmitting(false)
    }
  }

  return (
    <Formik
      initialValues={{confirmationCode: ''}}
      validationSchema={ConfirmationSchema}
      onSubmit={handleConfirmationSubmit}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <form onSubmit={handleSubmit} className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="confirmationCode"
            label={intl.formatMessage({id: 'confirmationCode'})}
            name="confirmationCode"
            autoFocus
            value={values.confirmationCode}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.confirmationCode && Boolean(errors.confirmationCode)}
            helperText={
              (touched.confirmationCode &&
                errors.confirmationCode &&
                intl.formatMessage({id: errors.confirmationCode})) ||
              intl.formatMessage({id: 'confirmRegistration.helpText'})
            }
          />
          <LoaderButton
            type="submit"
            isLoading={isSubmitting}
            loadingText={intl.formatMessage({id: 'confirmRegistration.confirming'})}
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            <FormattedMessage id="confirmRegistration.button" />
          </LoaderButton>
        </form>
      )}
    </Formik>
  )
}

export default SignUpConfirmationForm
